import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyADbSZbw0PAxVd0ao5CFASRKZ6UjSgDP1U",
  authDomain: "school-labels-kenya.firebaseapp.com",
  projectId: "school-labels-kenya",
  storageBucket: "school-labels-kenya.firebasestorage.app",
  messagingSenderId: "767959341966",
  appId: "1:767959341966:web:1290310227e5addb2062df",
  measurementId: "G-63ZFMT5GXH"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);



export {db, auth}

